import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=58992151&scoped=true&"
import script from "./FloatingChat.vue?vue&type=script&lang=js&"
export * from "./FloatingChat.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=58992151&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58992151",
  null
  
)

export default component.exports